import { render, staticRenderFns } from "./ListTokuisaki.vue?vue&type=template&id=436370d2&"
import script from "./ListTokuisaki.vue?vue&type=script&lang=ts&"
export * from "./ListTokuisaki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports